import { useSite } from '@v2/shared/lib/site';

/**
 * Turns a relative url into an absolute one.
 *
 * Urls are generated on the server and travel on the entities that own them, so this
 * deliberately builds nothing itself — there is no category or product builder here,
 * and there should not be one. What it does own is the base url, which is why paths
 * still have to pass through it: AU serves from https://www.discountmags.com/au/, and
 * rendering a bare `/categories/foo` there would drop the /au/ segment.
 *
 * The remaining builders headless_jshop had (home, cart, search, auto-renewals) went
 * with the templates that fed them. Known routes are written out at the call site;
 * anything genuinely dynamic — a search url takes a runtime term — needs a decision
 * about where it gets built, not a port.
 */
const useUrlGenerator = () => {
  const site = useSite();
  const baseUrl = site.base_url.replace(/\/$/, '');

  const buildUrl = (relativeUrl: string): string => `${baseUrl}${relativeUrl}`;

  return {
    buildUrl,
  };
};

export default useUrlGenerator;
